import React, {useEffect, useMemo, useRef, useState} from 'react'
import PageLayout from '../../../components/layout/PageLayout'
import WizButton from '../../../components/button/WizButton'
import {useTime} from '../../../utils/time'
import {useDisplayNumber} from '../../../utils/number'
import useQueryExchanges from '../../../hooks/etc/useQueryExchanges'
import useQueryGetLandingPopups from '../../../hooks/api/landing/popup/useQueryGetLandingPopups'
import Text from '../../../components/text/Text'
import useQueryPromotions from '../../../hooks/api/promotion/useQueryPromotions'
import WizImage from '../../../components/image/WizImage'
import {ILandingPopup} from '../../../apis/landing/popup/list'
import {postUploadImage} from '../../../apis/image/postUploadImage'
import UnderLineInput from '../../../components/input/UnderLineInput'
import WizSelectButton from '../../../components/button/WizSelectButton'
import {editLeaderboardBanner} from '../../../apis/banner/editLeaderboardBanner'
import {createPromotionItem} from '../../../apis/promotion/item/create'

interface IProps {
    className?: string
}

export function LandingPopup({className}: IProps) {
    const {data: exchanges} = useQueryExchanges()
    const [selectedPopup, setSelectedPopup] = useState<ILandingPopup['banner'] | null>(null)

    const {displayAmount} = useDisplayNumber()
    const {formatUTCDate, localTimeString, convertInputToTimezone, convertTimezoneToInput} = useTime()

    const {data, refetch} = useQueryGetLandingPopups()
    const {data: promotions} = useQueryPromotions(true)

    const list = useMemo(() => {
        // data extends promotions
        if (!data || !promotions) return []

        return data.map(popup => {
            const promotion = promotions.find(p => p.id === popup.promotion_set_id)
            return {
                ...popup,
                promotion_name: promotion?.name || '',
            }
        })
    }, [data, promotions])

    const imageRef = useRef<HTMLInputElement>(null)

    const onChangeImage = async e => {
        const imageFile = e?.target?.files[0]

        if (imageFile) {
            const result = await postUploadImage(imageFile, true, true)
            if (selectedPopup) {
                setSelectedPopup({...selectedPopup, pop_up_image: result.image_url})
            }
        }
    }

    const isViewList = useMemo(
        () => [
            {id: true, value: 'Show'},
            {id: false, value: 'Hide'},
        ],
        [],
    )

    return (
        <PageLayout title={'Landing Popup'} className="">
            <div>
                <WizButton
                    text={'New Landing Popup'}
                    type="primary"
                    onClick={async () => {
                        // await createPromotionItem({
                        //     id: 7,
                        //     data: {
                        //         promotion_set_id: 7,
                        //         slot: 'popup-event',
                        //         banner_oid: '69437857b5dbbeaaa29923af',
                        //     },
                        // })
                    }}
                />
            </div>

            <div className="grid grid-cols-[500px_1px_1fr] gap-x-[40px]">
                <div className="mt-[30px] flex flex-col gap-y-[10px]">
                    {list?.map((popup, index) => (
                        <div
                            key={popup?.banner?.id}
                            onClick={() => setSelectedPopup(popup?.banner)}
                            className="bg-white rounded-[5px] p-[20px] border border-line02 relative cursor-pointer hover:border-font04">
                            <div className="text-center absolute top-[20px] right-[20px]">
                                <Text
                                    className={`${
                                        popup?.banner?.is_active
                                            ? 'text-font_green bg-tag_green_light'
                                            : 'text-font_red bg-tag_red_light'
                                    } text-ti3 py-[2px] px-1 rounded-[4px]`}>
                                    {popup?.banner?.is_active ? 'Show' : 'Hide'}
                                </Text>
                            </div>
                            <div className="text-center">
                                <Text className="text-ti1 text-font01 text-center">{popup?.promotion_name}</Text>
                            </div>

                            <WizImage
                                src={popup?.banner?.pop_up_image}
                                className="h-[150px] mt-[10px] rounded-[5px] mx-auto"
                            />
                            <div className="text-center border-t border-t-line02 mt-[15px]">
                                <Text className="text-ti2 text-font02 space-y-1 pt-[10px]">Link</Text>
                                <Text>{popup?.banner?.button?.link}</Text>
                            </div>
                            <div className="flex items-center justify-between mt-[10px]">
                                <div className=" text-center">
                                    <Text className="text-ti2 text-font02 space-y-1 ">Banner ID</Text>
                                    <Text>{popup?.banner?.id}</Text>
                                </div>
                                <div className=" text-center">
                                    <Text className="text-ti2 text-font02 space-y-1">Promotion ID</Text>
                                    <Text>{popup?.promotion_set_id}</Text>
                                </div>
                            </div>

                            {/* <Text>{popup?.banner?.pop_up_image}</Text> */}
                        </div>
                    ))}
                </div>
                {selectedPopup && (
                    <>
                        <div className="bg-line02 mt-[20px]"></div>
                        <div className="bg-white p-[20px] border border-line02 rounded-[5px] mt-[20px] grid grid-cols-[400px_1fr] gap-x-[40px]">
                            <div
                                className="w-[400px] max-h-[450px] border border-line02 rounded-[5px] cursor-pointer"
                                onClick={() => imageRef.current?.click()}>
                                {selectedPopup?.pop_up_image ? (
                                    <WizImage
                                        src={selectedPopup?.pop_up_image}
                                        className="h-full"
                                        containerClassName="h-full"
                                    />
                                ) : (
                                    <Text className="text-body2 text-font03 h-full content-center text-center">
                                        None Image
                                    </Text>
                                )}
                                <input
                                    type={'file'}
                                    onChange={e => {
                                        onChangeImage(e)
                                    }}
                                    ref={imageRef}
                                    className={'hidden'}
                                />
                            </div>
                            <div className="w-full">
                                <div className="space-y-1">
                                    <Text className="text-ti2 text-font02">isActive</Text>
                                    <WizSelectButton
                                        data={isViewList}
                                        onChange={e => {
                                            setSelectedPopup({
                                                ...selectedPopup,
                                                is_active: e?.id as boolean,
                                            })
                                        }}
                                        activeValue={isViewList?.find(item => item?.id === selectedPopup?.is_active)}
                                    />
                                </div>
                                <div className="w-full mt-[10px] space-y-1">
                                    <Text className="text-ti2 text-font02">Link</Text>
                                    <UnderLineInput
                                        value={selectedPopup?.button?.link || ''}
                                        placeholder={'Popup Click Link'}
                                        className={'max-w-[500px] flex-1'}
                                        onChanged={text =>
                                            setSelectedPopup({
                                                ...selectedPopup,
                                                button: {...selectedPopup.button, link: text},
                                            })
                                        }
                                    />
                                </div>

                                <div className="mt-[40px]">
                                    <WizButton
                                        text={'Edit Landing Popup'}
                                        onClick={async () => {
                                            const result = await editLeaderboardBanner(selectedPopup)

                                            if (result?.data) {
                                                alert('Edit Complete Landing Popup')
                                                refetch()
                                                setSelectedPopup(null)
                                            } else {
                                                alert('Edit Error Landing Popup')
                                            }
                                        }}
                                        type="primary"
                                    />
                                </div>
                            </div>
                        </div>
                    </>
                )}
            </div>
        </PageLayout>
    )
}
